import { render, staticRenderFns } from "./UserAssingRolesModal.vue?vue&type=template&id=1b7de8e8&scoped=true&"
import script from "./UserAssingRolesModal.vue?vue&type=script&lang=js&"
export * from "./UserAssingRolesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7de8e8",
  null
  
)

export default component.exports